import { useEffect, useState } from "react";
import Institution from "./Institution";
import Arrangement from "./Arrangement";
import Salary from "./Salary";
import Remark from "./Remark";
import Contracts from "./Contracts";
import Log from "./Log";
import { Card, CardBody } from "reactstrap";
import Loader from "react-loaders";

import { useGebruikerContext } from "../../Context/GebruikerContext";
import { InstelligenProvider } from "./Context/InstellingenContext";
import Footer from "./Footer";

const Instellingen = ({ children }) => {
	const { isLoading } = useGebruikerContext();

	if (isLoading) {
		return (
			<Card className="main-card">
				<CardBody className="d-flex flex-column">
					<Loader
						type="ball-grid-pulse"
						className={"mt-3 d-flex mx-auto justify-content-center"}
					/>
				</CardBody>
			</Card>
		);
	}

	return (
		<InstelligenProvider>
			{children}
		</InstelligenProvider>
	);
};

Instellingen.Wrapper = ({ children }) => {
	return <div className="row instellingen">{children}</div>;
};

Instellingen.Footer = () => {
	return <Footer />;
};

Instellingen.Institution = () => {
	return (
		<div className="col-xxl-4">
			<Institution />
		</div>
	);
};

Instellingen.Arrangement = () => {
	return (
		<div className="col-xxl-4">
			<Arrangement />
		</div>
	);
};

Instellingen.Salary = () => {
	return (
		<div className="col-xxl-4">
			<Salary />
		</div>
	);
};

Instellingen.Remark = () => {
	return (
		<div className="col-12">
			<Remark />
		</div>
	);
};

Instellingen.Contracts = () => {
	return (
		<div className="col-12">
			<Contracts />
		</div>
	);
};

Instellingen.Log = () => {
	return (
		<div className="col-12">
			<Log />
		</div>
	);
};

export default Instellingen;
